module.exports = __webpack_public_path__ + "static/img/影像@3x.4afe85f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/影像@3x.png
// module id = 786
// module chunks = 382